export default __webpack_public_path__ + "static/media/organism-new.4bd99b79.jpg";